import template from 'header/cart.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-cart__a:visible',
        watch: 'core.cart',
        name: 'cartCountComponent',
        renderType: dDom,
        template: template
    };
    return generate(config, store, overrides);
}

